<main class="main-container">
	<div class="main-container--inner">
		<header class="main-container--header">
			<a routerLink="/">
				<img src="/assets/images/ApplioSpacesLogo.png" width="500" height="60" alt="ApplioSpaces" />
			</a>
		</header>
		<section class="main-container--content">
			<ng-content></ng-content>
		</section>
		<footer class="main-container--footer">
			<p>Copyright &#169; {{ date | date: 'YYYY' }} Applio Spaces. All rights reserved.</p>
		</footer>
	</div>
</main>
<aside class="image-container" aria-hidden="true"></aside>